export enum CashManagementTransactionType {
  Adjustment = 'adjustment',
  Deposit = 'deposit',
  Withdrawal = 'withdrawal',
  StripeTransfer = 'stripe_transfer',
  ResidentDeposit = 'resident deposit',
  ResidentWithdrawal = 'resident withdrawal',
}
